import React from "react";
import classnames from "classnames";
import styles from "./TurnrAlert.module.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faCircleInfo, faTriangleExclamation } from "@fortawesome/pro-regular-svg-icons";

export const typeToIcon = {
    SUCCESS: faCheck,
    ERROR: faTriangleExclamation,
    WARNING: faCircleInfo,
    INFO: faCircleInfo,
};

const sizes = { small: "12px", medium: "14px", large: "18px", xl: "22px" };

export function TurnrFontAwesomeIcon(props) {
    let { icon, color, size = "small", width, style } = props;
    const actualSize = width ? width : sizes[size] || sizes.small;
    return <FontAwesomeIcon icon={icon} color={color ? color : undefined} style={{ width: actualSize, height: actualSize, ...style }} />;
}

export function TurnrAlert({ title, content, type = "INFO", children, fullWidth, className, style }) {
    return (
        <div className={classnames(styles["popup-inner"], styles["popup-" + type], className)} style={{ ...style, width: fullWidth && "100%" }}>
            {/*{onClose && <div style={{position: "absolute", top: 7, right: 7}} onClick={onClose}>*/}
            {/*    <TurnrCloseIconButton className={styles["close-icon"]} color={"white"}/>*/}
            {/*</div>}*/}

            <div className={styles["content-wrapper"]}>
                {/*{showIcon  && <div><TurnrFontAwesomeIcon icon={typeToIcon[type]} width={"18px"}*/}
                {/*                                         style={{marginTop: "-1px"}}/></div>}*/}
                <div className={styles["content"]}>
                    {title && <h2 className={styles["popup-header"]}>{title}</h2>}
                    {content || (children && <div className={styles["popup-content"]}>{content || children}</div>)}
                </div>
            </div>
        </div>
    );
}

export function TurnrInfoAlert(props) {
    return <TurnrAlert type="INFO" {...props} />;
}

export function TurnrWarningAlert(props) {
    return <TurnrAlert type="WARNING" {...props} />;
}

export function TurnrErrorAlert(props) {
    return <TurnrAlert type="ERROR" {...props} />;
}

export function TurnrSuccessAlert(props) {
    return <TurnrAlert type="SUCCESS" {...props} />;
}
